const routes = [
  {
    path: 'drawflow',
    name: 'drawflow',
    component: () => import(/* webpackChunkName: "drawflow" */ '@/modules/drawflow/index.vue'),
    children: [
      {
        path: '',
        name: 'drawflow',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/drawflow/demo1.vue')
      },
      {
        path: 'demo1',
        name: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/drawflow/demo1.vue')
      },
      {
        path: 'demo2',
        name: 'demo2',
        component: () => import(/* webpackChunkName: "demo2" */ '@/modules/drawflow/demo2.vue')
      },
      {
        path: 'demo3',
        name: 'demo3',
        component: () => import(/* webpackChunkName: "demo3" */ '@/modules/drawflow/demo3.vue')
      },
    ]
  },
];

export default routes;